import { DEFAULT_LANGUAGE } from '../../../core/config';
import { formatNumberWithTwoFractionDigits } from '../../timeseries-statistics/NumberFormatter';
import { ClassOfService } from './ClassOfService.model';
import { SlaMetrics } from './SlaMetrics.model';

export interface SlaMonitoredServiceApiModel {
  itemId: number;
  name: string;
  orderNumber: number;
  classesOfService: ClassOfService[];
}

export interface SlaMonitoredClassOfServiceViewModel {
  id: string;
  itemId: number;
  serviceName?: string;
  slaMetrics: {
    jitter: string;
    delay: string;
    lossRatio: string;
  };
  classOfServiceName: string;
  cosId: number;
  orderNumber: number;
}

export const mapSlaMonitoredServiceApiToViewModel = (monitoredServices: SlaMonitoredServiceApiModel[]): SlaMonitoredClassOfServiceViewModel[] =>
  monitoredServices.flatMap(monitoredService => mapMonitoredServiceClassesOfServiceToViewModel(monitoredService));

const mapMonitoredServiceClassesOfServiceToViewModel = (monitoredService: SlaMonitoredServiceApiModel): SlaMonitoredClassOfServiceViewModel[] =>
  monitoredService.classesOfService.map(({ name, cosId, slaMetrics }) =>
     mapMonitoredServiceClassOfServiceToViewModel(monitoredService, name, cosId, slaMetrics));

const mapMonitoredServiceClassOfServiceToViewModel = (
  monitoredService: SlaMonitoredServiceApiModel, 
  name: string,
  cosId: number,
  slaMetrics?: SlaMetrics
) : SlaMonitoredClassOfServiceViewModel => ({
  id: `${monitoredService.itemId}-${cosId}`,
  itemId: monitoredService.itemId,
  orderNumber: monitoredService.orderNumber,
  slaMetrics: {
    delay: slaMetrics?.delay === undefined ? '' : displayWithTwoFractionDigits(slaMetrics.delay),
    jitter: slaMetrics?.jitter === undefined ? '' : displayWithTwoFractionDigits(slaMetrics.jitter),
    lossRatio: slaMetrics?.lossRatio === undefined ? '' : displayWithPercentSign(slaMetrics.lossRatio)
  },
  cosId,
  classOfServiceName: name,
  serviceName: monitoredService.name || '',
});

const displayWithPercentSign = (value: number): string => {
  return displayWithTwoFractionDigits(value) + '%';
};

const displayWithTwoFractionDigits = (value: number): string => {
  return formatNumberWithTwoFractionDigits(value, DEFAULT_LANGUAGE.code, '');
};